'use client';

import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { FALLBACK_RESOURCE_CENTER_URL } from '../../constant/url';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader } from '../modal/drawer/Drawer';
import { Card } from '../organisms';

export const BankListDrawer = NiceModal.create(
  ({ banks, onSelect, onClose }: { banks: Bank[]; onSelect: (bankCode: string) => void; onClose?: () => void }) => {
    const modal = useModal();

    return (
      <Drawer open={modal.visible} onOpenChange={onClose}>
        <DrawerContent>
          <DrawerHeader className={'heading-small-bold'}>은행을 선택해주세요</DrawerHeader>
          <DrawerBody className={'!pt-tiny-large !px-normal-medium grid grid-cols-4 xs:!grid-cols-3'}>
            {banks.map(({ bankCode, bankName, bankIconFileName }) => {
              return (
                <Card
                  key={bankCode}
                  className={
                    'caption-small-semibold flex cursor-pointer flex-col items-center justify-center gap-tiny-large px-tiny-medium py-normal-medium text-center text-neutral-foreground-main focus-visible:bg-card-gradient focus-visible:outline-none'
                  }
                  outline={false}
                  action
                  role={'button'}
                  tabIndex={0}
                  aria-label={`${bankName} 선택`}
                  onClick={() => {
                    onSelect(bankCode);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      event.currentTarget.click();
                    }
                  }}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL ?? FALLBACK_RESOURCE_CENTER_URL}/common/logo/external/${bankIconFileName}.svg`}
                    className={'size-regular-medium'}
                    alt={''}
                  />
                  {bankName}
                </Card>
              );
            })}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }
);

export type Bank = {
  bankCode: string;
  bankIconFileName: string;
  bankName: string;
};
